(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(() => {
  let keyboardInteraction = false;
  const stickyFrames = new WeakMap();
  let viewRevision = 0;
  let lastCartEvent;
  let pageRefresh;
  const renderedPages = new WeakSet();
  const pageSections = () => ['main-cart-items','main-cart-footer'].flatMap(id => {
    const element = document.getElementById(id);
    return element?.dataset.id ? [{id:element.dataset.id, selector:'#'+id+' .js-contents'}] : [];
  });
  function renderPage(sections) {
    const parts = pageSections();
    if (!parts.length) return true;
    if (sections && renderedPages.has(sections)) return true;
    const parsed = parts.map(part => {
      const html = sections?.[part.id];
      return html && new DOMParser().parseFromString(html,'text/html').querySelector(part.selector);
    });
    if (parsed.some(part => !part)) return false;
    parts.forEach((part,index) => {
      const target = document.querySelector(part.selector);
      target.innerHTML = parsed[index].innerHTML;
      const container = target.closest('#main-cart-items, #main-cart-footer');
      const source = parsed[index].closest('#main-cart-items, #main-cart-footer');
      container.classList.toggle('is-empty',source.classList.contains('is-empty'));
    });
    renderedPages.add(sections);
    return true;
  }
  async function refreshPage() {
    if (!pageSections().length) return;
    if (pageRefresh) return pageRefresh;
    const revision = viewRevision;
    const url = new URL((window.Shopify?.routes?.root || '/')+'cart',location.origin);
    url.searchParams.set('sections',pageSections().map(part => part.id).join(','));
    pageRefresh = fetch(url,{credentials:'same-origin',cache:'no-store'})
      .then(response => { if (!response.ok) throw new Error('Cart refresh failed.'); return response.json(); })
      .then(sections => {
        if (revision !== viewRevision) return;
        if (!renderPage(sections)) throw new Error('Cart page sections unavailable.');
      }).finally(() => { pageRefresh = null; });
    return pageRefresh;
  }
  window.SissiluxCartViews = {renderPage, refreshPage};
  // Conditional upsells can enter or leave the drawer. Shrine 1.9 copies
  // their state by DOM index, which can copy a warranty variant into a pad.
  // Keep its existing state-copy routine, supplying nodes in product order.
  const toggleSelector = 'cart-drawer-upsell[data-toggle="true"], cart-drawer-gift';
  const pendingUpsells = new Set();
  let upsellFrame = 0;
  function queueNewUpsells(drawer, html) {
    if (!html) return;
    const source = new DOMParser().parseFromString(html, 'text/html');
    const existing = new Map([...drawer.querySelectorAll('cart-drawer-upsell')].map(node => [node.dataset.handle, node]));
    source.querySelectorAll('cart-drawer-upsell[data-toggle="true"][data-selected="true"]:not([data-siss-warranty-native]):not([data-siss-managed-addon])').forEach(node => {
      const previousMask = existing.get(node.dataset.handle)?.closest('[data-bfcm-hand-mask]');
      const nextMask = node.closest('[data-bfcm-hand-mask]');
      const gainedRetailTrigger = previousMask?.dataset.originalDisplay === 'false' && nextMask?.dataset.originalDisplay === 'true';
      if (!existing.has(node.dataset.handle) || gainedRetailTrigger) pendingUpsells.add(node.dataset.handle);
    });
  }
  function addPendingUpsell(drawer) {
    cancelAnimationFrame(upsellFrame);
    upsellFrame = requestAnimationFrame(() => {
      for (const handle of pendingUpsells) {
        pendingUpsells.delete(handle);
        const node = [...drawer.querySelectorAll('cart-drawer-upsell')].find(node => node.dataset.handle === handle);
        if (!node || drawer.querySelector('.cart-item--product-' + handle)) continue;
        // Use the existing product form and cart queue, one addition per render.
        node.dataset.selected = 'true';
        node.addToCart();
        break;
      }
    });
  }
  function reconcileUpsells() {
    const drawer = document.querySelector('cart-drawer');
    drawer?.querySelectorAll('cart-drawer-upsell[data-toggle="true"]:not([data-siss-warranty-native]), cart-drawer-upsell[data-siss-managed-addon]').forEach(upsell => {
      // Reconcile both directions after a server render, including deletion
      // from the cart page rather than through this upsell's own toggle.
      upsell.dataset.selected = String(Boolean(drawer.querySelector('.cart-item--product-'+upsell.dataset.handle)));
    });
  }

  // These paid add-ons own only lines bearing their private source marker.
  // Eligibility comes from the latest server-rendered blocks, never gift intent.
  let addonCart = null;
  let addonPending = null;
  let addonFailure = '';
  let addonSettledKey = '';
  const addonChoices = new Map();
  const addonPreferences = new Map();
  const addonSelector = 'cart-drawer-upsell[data-siss-managed-addon]';
  const addonNode = handle => [...document.querySelectorAll(addonSelector)].find(node => node.dataset.handle === handle);
  const parseAddonJSON = node => { try { return JSON.parse(node?.textContent || 'null'); } catch (_) { return null; } };
  function acceptAddonCart(response) {
    let cart = Array.isArray(response?.items) && typeof response.token === 'string' ? response : null;
    if (!cart && response?.sections?.['cart-drawer']) {
      const source = new DOMParser().parseFromString(response.sections['cart-drawer'], 'text/html');
      cart = parseAddonJSON(source.querySelector('[data-siss-cart-snapshot]'));
      if (cart && !cart.token && addonCart?.token) cart.token = addonCart.token;
    }
    if (Array.isArray(cart?.items)) {
      addonCart = cart;
      if (typeof cart.token === 'string' && typeof cart.currency === 'string' && Number.isFinite(cart.items_subtotal_price)) {
        const snapshot = document.querySelector('cart-drawer [data-siss-cart-snapshot]');
        if (snapshot) {
          const snapshotCart = {...cart};
          delete snapshotCart.sections;
          snapshot.textContent = JSON.stringify(snapshotCart).replace(/</g, '\\u003c');
        }
        window.SissiluxDiscounts?.acceptCart?.(cart);
      }
    }
    return cart;
  }
  function addonConfigs(root = document) {
    const view = root.querySelector('cart-drawer [data-bfcm-rewards]');
    const state = parseAddonJSON(view?.querySelector('[data-gpt-gift-state]')) || {};
    const campaign = ['multiple','tiered'].includes(state.selectionMode) && state.campaignEnabled && Number(state.eligibleQuantity) > 0;
    return [...root.querySelectorAll('cart-drawer [data-siss-addon-config]')].flatMap(node => {
      const config = parseAddonJSON(node);
      if (!config) return [];
      const eligible = config.countryAllowed && (config.triggered || (config.handMask && campaign));
      return (config.products || []).map(product => ({...product, eligible, retain:config.countryAllowed && (config.retain || eligible)}));
    });
  }
  function addonOptOuts(cart) {
    const token = String(cart?.token || '').split('?')[0];
    if (!token) throw new Error('The cart is not ready to save your add-on choice.');
    const key = 'sissilux:addons:optout:' + token;
    if (!addonPreferences.has(key)) {
      let saved = [];
      try { saved = JSON.parse(localStorage.getItem(key) || '[]'); } catch (_) {}
      addonPreferences.set(key, new Set(Array.isArray(saved) ? saved : []));
    }
    const values = addonPreferences.get(key);
    for (const [handle, choice] of addonChoices) {
      if (choice.cartToken && choice.cartToken !== token) { addonChoices.delete(handle); continue; }
      if (choice.selected) values.delete(handle); else values.add(handle);
    }
    try { localStorage.setItem(key, JSON.stringify([...values])); } catch (_) {}
    return values;
  }
  const paidAddonLines = (cart, config) => cart.items.filter(item => String(item.product_id) === String(config.productId) && Number(item.original_price) > 0 && item.properties?._gpt_gift !== 'true');
  function addonPlan(cart, configs, optedOut) {
    const updates = {}, items = [];
    for (const config of configs) {
      const lines = paidAddonLines(cart, config), choice = addonChoices.get(config.handle);
      const owned = lines.filter(line => line.properties?._siss_cart_addon === config.owner);
      if (choice?.selected === false) {
        lines.forEach(line => { updates[line.key] = 0; });
        if (!lines.length) addonChoices.delete(config.handle);
        continue;
      }
      if (!config.retain) owned.forEach(line => { updates[line.key] = 0; });
      if (!config.eligible || !config.available) continue;
      const variantId = String(choice?.variantId || config.variantId);
      if (choice?.selected && lines.length && lines.some(line => String(line.variant_id) !== variantId)) {
        lines.forEach(line => { updates[line.key] = 0; });
        continue;
      }
      if (!lines.length && (choice?.selected || (config.defaultSelected && !optedOut.has(config.handle))) && /^\d+$/.test(variantId) && Number(variantId) > 0) {
        items.push({id:variantId, quantity:1, properties:{_siss_cart_addon:config.owner}});
      } else if (lines.length && choice?.selected) addonChoices.delete(config.handle);
    }
    return {updates, items};
  }
  // R63: one customer quantity edit owns dependent writes and one final paint.
  let quantityTransaction = null;
  let quantityTransactionBlocked = false;
  const transactionHeld = () => Boolean(quantityTransaction || quantityTransactionBlocked);
  function transactionState(root = document) {
    return parseAddonJSON(root.querySelector('[data-gpt-gift-state]'));
  }
  function transactionEnabled() {
    const state = transactionState();
    return state?.selectionMode === 'tiered' && state.managementEnabled &&
      Boolean(window.__gptGiftControllerV2?.tierTarget && window.SissiluxWarranty?.planCart);
  }
  function transactionSections() {
    const drawer = document.querySelector('cart-drawer');
    const ids = [...new Set([
      ...(drawer?.getSectionsToRender?.() || []).map(part => part.id),
      ...pageSections().map(part => part.id)
    ])];
    if (!ids.includes('cart-drawer') || ids.length > 5) throw new Error('Cart sections are unavailable.');
    return ids;
  }
  function transactionResponse(result) {
    const markup = result?.sections?.['cart-drawer'];
    if (typeof markup !== 'string') throw new Error('The updated cart needs confirmation.');
    const html = new DOMParser().parseFromString(markup, 'text/html');
    const snapshot = parseAddonJSON(html.querySelector('[data-siss-cart-snapshot]'));
    const cart = Array.isArray(result.items) && typeof result.token === 'string' ? result : snapshot;
    if (cart && !cart.token) cart.token = addonCart?.token || window.SissiluxDiscounts?.cart?.token;
    if (!Array.isArray(cart?.items) || typeof cart.token !== 'string' ||
        !Number.isFinite(cart.items_subtotal_price)) throw new Error('The updated cart needs confirmation.');
    return {cart:{...cart, sections:result.sections}, html, state:transactionState(html)};
  }
  async function transactionWrite(endpoint, values, sections) {
    const response = await fetch((window.Shopify?.routes?.root || '/') + endpoint, {
      method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'},
      body:JSON.stringify({...values, sections, sections_url:location.pathname}),
      signal:AbortSignal.timeout(12000)
    });
    const result = await response.json();
    if (!response.ok || result.errors || result.status) throw new Error(result.description || 'We could not update your cart.');
    return transactionResponse(result);
  }
  function transactionGiftPlan(view, gifts) {
    const state = view.state;
    if (!state || state.selectionMode !== 'tiered' || !state.managementEnabled) {
      // An empty drawer can omit the reward block. Never infer a new gift.
      if (!view.cart.items.length) return {updates:{}, items:[]};
      throw new Error('The gift rules need confirmation.');
    }
    const working = {...state, giftLines:(state.giftLines || []).map(line => ({...line}))};
    const target = gifts.tierTarget(working), updates = {}, items = [];
    const limit = working.giftLines.length + target.size + 1;
    for (let count = 0; count < limit; count++) {
      const correction = gifts.quantityCorrection(working, target);
      if (!correction?.line) break;
      const line = working.giftLines.find(item => item.key === correction.line.key);
      if (!line || !view.cart.items.some(item => item.key === line.key)) throw new Error('The gift line changed.');
      updates[line.key] = correction.quantity;
      if (correction.quantity === 0) working.giftLines = working.giftLines.filter(item => item !== line);
      else line.quantity = correction.quantity;
    }
    // Remove invalid gifts first. Their dependent accessory flags in Liquid
    // may remain true until that removal is confirmed by the next response.
    if (Object.keys(updates).length) return {updates, items};
    const quantities = gifts.giftQuantities(working);
    for (const [id, quantity] of target) {
      const missing = quantity - (quantities.get(id) || 0);
      if (missing <= 0) continue;
      gifts.assertSelectable(state, id);
      const form = view.html.querySelector('[data-gpt-gift-product-form] form');
      if (!form) throw new Error('The gift form is unavailable.');
      const properties = {};
      form.querySelectorAll('input[name^="properties["]').forEach(input => {
        const match = input.name.match(/^properties\[([^\]]+)\]$/);
        if (match) properties[match[1]] = input.value;
      });
      if (properties._gpt_gift !== 'true') throw new Error('The gift form is unavailable.');
      properties._gpt_gift_tier = String(state.activeTier);
      items.push({id, quantity:missing, properties});
    }
    return {updates, items};
  }
  async function settleQuantityTransaction(view, sections, gifts) {
    const seen = new Set();
    for (let round = 0; round < 10; round++) {
      const giftPlan = transactionGiftPlan(view, gifts);
      const configs = addonConfigs(view.html);
      const extras = addonPlan(view.cart, configs, addonOptOuts(view.cart));
      const warranty = await window.SissiluxWarranty.planCart(view.cart);
      const updates = {...giftPlan.updates, ...extras.updates, ...warranty.updates};
      const items = [...giftPlan.items, ...extras.items];
      if (!Object.keys(updates).length && !items.length) return view;
      const signature = JSON.stringify([view.cart.items.map(item => [item.key,item.quantity]),updates,items]);
      if (seen.has(signature)) throw new Error('The cart update was not confirmed.');
      seen.add(signature);
      view = await transactionWrite(Object.keys(updates).length ? 'cart/update.js' : 'cart/add.js',
        Object.keys(updates).length ? {updates} : {items}, sections);
    }
    throw new Error('The cart changed while updating. Please retry.');
  }
  function changeCartQuantity(element, line, quantity, name) {
    const gifts = window.__gptGiftControllerV2, warranty = window.SissiluxWarranty;
    if (transactionHeld() || addonPending || dependentCleanupQueued || gifts.operationCount > 0 || gifts.tierWorkerQueued || !warranty.beginQuantity(line)) {
      // A previous write already owns the controls; do not start a second lane.
      warranty.cancelRejectedQuantity?.(line);
      return Promise.resolve(false);
    }
    rememberAddonRemoval(line, quantity);
    viewRevision++;
    quantityTransaction = Promise.resolve().then(async () => {
      let confirmed = null, failure = null;
      try {
        const sections = transactionSections();
        let view = await transactionWrite('cart/change.js', {line:Number(line),quantity:Number(quantity)}, sections);
        if (gifts.tierChoiceIntent?.context !== gifts.tierContext(view.state || {})) gifts.tierChoiceIntent = null;
        view = await settleQuantityTransaction(view, sections, gifts);
        confirmed = view.cart;
        addonCart = confirmed;
        addonSettledKey = addonWorkKey(confirmed, addonConfigs(view.html));
        addonFailure = '';
        gifts.tierFailureSignature = '';
        gifts.tierChoiceIntent = null;
        // All observers receive the same final state. No intermediate publish,
        // DOM replacement, cached-cart read, or native focus reset occurs.
        window.SissiluxDiscounts?.acceptCart?.(confirmed);
        const drawer = document.querySelector('cart-drawer');
        const empty = confirmed.item_count === 0;
        drawer.classList.toggle('is-empty', empty);
        document.querySelectorAll('cart-items, cart-drawer-items').forEach(items => items.classList.toggle('is-empty', empty));
        document.getElementById('main-cart-footer')?.classList.toggle('is-empty', empty);
        drawer.renderContents(confirmed, true);
        if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, {source:'cart-items',cartData:confirmed});
        if (name && keyboardInteraction) {
          const input = document.querySelector((element.nodeName === 'CART-ITEMS' ? '#Quantity-' : '#Drawer-quantity-') + line);
          input?.focus({preventScroll:true});
        }
        return true;
      } catch (error) {
        failure = error;
        quantityTransactionBlocked = true;
        return false;
      } finally {
        // An uncertain request is not resent. Warranty's existing retry flow
        // reads the server before permitting any further dependent writes.
        quantityTransaction = null;
        warranty.finishQuantity(confirmed, failure);
        gifts.syncViews();
        reconcileUpsells();
      }
    });
    gifts.syncViews();
    return quantityTransaction;
  }
  window.SissiluxCartTransactions = {
    handles:transactionEnabled, changeQuantity:changeCartQuantity,
    get pending(){return Boolean(quantityTransaction);}, get held(){return transactionHeld();},
    get busy(){return transactionHeld() || Boolean(addonPending || dependentCleanupQueued || window.__gptGiftControllerV2?.operationCount > 0 || window.__gptGiftControllerV2?.tierWorkerQueued);},
    resumeAfterRecovery() {
      if (!quantityTransactionBlocked) return;
      quantityTransactionBlocked = false;
      window.__gptGiftControllerV2?.requestReconciliation();
      scheduleManagedAddons();
    }
  };

  async function settleAddons() {
    const warranty = window.SissiluxWarranty;
    if (warranty?.ensure) {
      // Pass the confirmed snapshot so an unchanged cart does not need a GET.
      const confirmed = addonCart && typeof addonCart.token === 'string' && Number.isFinite(addonCart.items_subtotal_price) ? addonCart : undefined;
      const settled = await warranty.ensure(confirmed);
      if (Array.isArray(settled?.items)) addonCart = settled;
    } else {
      const cart = await window.SissiluxDiscounts?.refreshCart?.();
      if (Array.isArray(cart?.items)) addonCart = cart;
    }
    if (!addonCart?.token || !Array.isArray(addonCart.items)) throw new Error('The cart is not ready to update add-ons.');
    return addonCart;
  }
  async function mutateAddons(endpoint, values) {
    const drawer = document.querySelector('cart-drawer');
    const sections = [...new Set(drawer.getSectionsToRender().map(part => part.id))];
    const response = await fetch((window.Shopify?.routes?.root || '/') + endpoint, {
      method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'},
      body:JSON.stringify({...values, sections, sections_url:location.pathname}), signal:AbortSignal.timeout(12000)
    });
    const result = await response.json();
    if (!response.ok || result.errors || result.status) throw new Error(result.description || 'We could not update your add-ons.');
    const cart = acceptAddonCart(result);
    if (!cart || !result.sections?.['cart-drawer']) throw new Error('The add-on update needs confirmation.');
    const confirmed = {...cart, sections:result.sections};
    window.SissiluxDiscounts?.acceptCart?.(confirmed);
    drawer.renderContents(confirmed, true);
    if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, {source:'sissilux-addons', cartData:confirmed});
    return cart;
  }
  const addonWorkKey = (cart, configs) => JSON.stringify([cart?.token, cart?.items?.map(line => [line.key,line.quantity]), configs, [...addonChoices]]);
  async function reconcileManagedAddons() {
    for (let round = 0; round < 8; round++) {
      const cart = await settleAddons();
      const configs = addonConfigs(), key = addonWorkKey(cart, configs);
      if (addonFailure === key) return;
      const plan = addonPlan(cart, configs, addonOptOuts(cart));
      const removing = Object.keys(plan.updates).length > 0;
      if (!removing && !plan.items.length) {
        addonSettledKey = addonWorkKey(cart, configs);
        addonFailure = '';
        return;
      }
      try {
        const result = await mutateAddons(removing ? 'cart/update.js' : 'cart/add.js', removing ? {updates:plan.updates} : {items:plan.items});
        const confirmed = removing
          ? Object.keys(plan.updates).every(key => !result.items.some(line => line.key === key))
          : plan.items.every(item => result.items.some(line => String(line.variant_id) === item.id && line.properties?._siss_cart_addon === item.properties._siss_cart_addon && Number(line.quantity) > 0));
        if (!confirmed) throw new Error('The cart did not confirm the add-on update.');
        addonFailure = '';
      } catch (error) {
        // An interrupted response can still have committed. Recover once, then
        // wait for a new choice/cart state instead of blindly resending a charge.
        try {
          const recovered = await window.SissiluxWarranty?.ensure?.(undefined, true, true);
          if (Array.isArray(recovered?.items)) addonCart = recovered;
        } catch (_) {}
        addonFailure = addonWorkKey(addonCart, addonConfigs());
        throw error;
      }
    }
    throw new Error('The cart changed while updating add-ons. Please try again.');
  }
  function scheduleManagedAddons() {
    if (transactionHeld()) return quantityTransaction;
    if (addonPending) { setAddonsBusy(true); return addonPending; }
    const configs = addonConfigs();
    if (!configs.length) return;
    const key = addonWorkKey(addonCart, configs);
    if (key === addonSettledKey || key === addonFailure) return;
    setAddonsBusy(true);
    // The gift queue finishes replacement before add-ons inspect eligibility.
    const gifts = window.__gptGiftControllerV2;
    addonPending = Promise.resolve().then(() => gifts?.enqueue ? gifts.enqueue(reconcileManagedAddons) : reconcileManagedAddons())
      .catch(error => {
        addonFailure = addonWorkKey(addonCart, addonConfigs());
        const message = document.getElementById('CartDrawer-CartErrors');
        if (message) message.textContent = error.message || 'We could not update your add-ons. Please try again.';
        console.warn('Paid add-on update was not confirmed.', error);
      }).finally(() => {
        addonPending = null; setAddonsBusy(false); reconcileUpsells();
        if (!addonFailure && addonWorkKey(addonCart, addonConfigs()) !== addonSettledKey) queueMicrotask(scheduleManagedAddons);
      });
    return addonPending;
  }
  function setAddonsBusy(active) {
    document.querySelectorAll(addonSelector).forEach(node => {
      if (active) node.setAttribute('aria-busy', 'true'); else node.removeAttribute('aria-busy');
      node.querySelectorAll('.upsell-toggle-btn, select').forEach(control => {
        if (active && !control.disabled) { control.dataset.sissAddonBusy = 'true'; control.disabled = true; }
        else if (!active && control.dataset.sissAddonBusy === 'true') {
          delete control.dataset.sissAddonBusy;
          if (!window.SissiluxWarranty?.busy) control.disabled = false;
        }
      });
    });
  }
  function chooseManagedAddon(handle, selected, variantId) {
    addonChoices.set(handle, {selected, variantId, cartToken:String(addonCart?.token || '').split('?')[0]});
    addonFailure = '';
    if (addonCart?.token) addonOptOuts(addonCart);
    return scheduleManagedAddons();
  }
  function rememberAddonRemoval(index, quantity) {
    if (Number(quantity) !== 0) return;
    const line = addonCart?.items?.[Number(index)-1];
    const config = addonConfigs().find(config => String(config.productId) === String(line?.product_id));
    if (config) {
      addonChoices.set(config.handle, {selected:false, cartToken:String(addonCart?.token || '').split('?')[0]});
      addonFailure = '';
      if (addonCart?.token) addonOptOuts(addonCart);
    }
  }
  document.addEventListener('click', event => {
    const node = event.target.closest?.('.upsell-toggle-btn')?.closest(addonSelector);
    if (!node) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (addonPending || window.SissiluxWarranty?.busy || event.target.closest('.upsell-toggle-btn').disabled) return;
    chooseManagedAddon(node.dataset.handle, node.dataset.selected !== 'true', node.dataset.id);
  }, true);
  let addonCheckoutPending = false;
  let addonCheckoutReplay = false;
  document.addEventListener('click', async event => {
    const button = event.target.closest?.('button[name="checkout"], a[href$="/checkout"]');
    if (!button || addonCheckoutReplay || (!addonPending && !addonCheckoutPending)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (addonCheckoutPending) return;
    addonCheckoutPending = true;
    try {
      for (let round = 0; round < 8 && addonPending; round++) await addonPending;
      if (addonPending) return;
      const current = button.id ? document.getElementById(button.id) : button;
      if (!current?.isConnected) return;
      // Replay through the existing gift and warranty guards with confirmed totals.
      addonCheckoutReplay = true;
      current.click();
    } finally { addonCheckoutReplay = false; addonCheckoutPending = false; }
  }, true);
  document.addEventListener('sissilux:bfcm-state', scheduleManagedAddons);
  window.SissiluxCartAddons = {ensure:scheduleManagedAddons, get pending(){return Boolean(addonPending);}};

  let dependentCleanupQueued = false;
  const orphanUpsells = () => [...document.querySelectorAll('cart-drawer [data-siss-orphan-upsell]')];
  async function removeOrphanUpsells() {
    const attempted = new Set();
    while (orphanUpsells().length) {
      // Reuse the same settlement and native quantity path as gift removal.
      // Read the key and line index only after warranty/gift work has settled.
      await window.SissiluxWarranty?.ensure?.();
      const marker = orphanUpsells()[0];
      if (!marker) return;
      const key = marker.dataset.lineKey;
      const index = Number(marker.dataset.lineIndex);
      const drawerItems = document.querySelector('cart-drawer-items');
      if (!key || attempted.has(key) || !Number.isInteger(index) || index < 1 || !drawerItems?.updateQuantity) {
        throw new Error('Dependent upsell cleanup could not confirm the current cart line.');
      }
      attempted.add(key);
      const result = await drawerItems.updateQuantity(index, 0);
      if (result === false || orphanUpsells().some(node => node.dataset.lineKey === key)) {
        throw new Error('Dependent upsell removal was not confirmed.');
      }
    }
  }
  function scheduleDependentUpsellCleanup() {
    if (transactionHeld()) return;
    if (dependentCleanupQueued || !orphanUpsells().length) return;
    dependentCleanupQueued = true;
    queueMicrotask(() => {
      const gifts = window.__gptGiftControllerV2;
      // Share the gift controller's queue: no removal may race a gift change.
      const operation = gifts?.enqueue
        ? gifts.enqueue(removeOrphanUpsells)
        : removeOrphanUpsells();
      Promise.resolve(operation).catch(error => {
        console.warn('Dependent upsell cleanup will retry after the next cart update.', error);
      }).finally(() => { dependentCleanupQueued = false; });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { scheduleDependentUpsellCleanup(); scheduleManagedAddons(); }, {once:true});
  } else {
    scheduleDependentUpsellCleanup();
    scheduleManagedAddons();
  }

  if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate,event => {
    viewRevision++;
    lastCartEvent = event;
    acceptAddonCart(event?.cartData);
    queueMicrotask(scheduleDependentUpsellCleanup);
    queueMicrotask(scheduleManagedAddons);
  });
  function bundleCartViews(items) {
    const other = document.querySelector(items.nodeName === 'CART-ITEMS' ? 'cart-drawer-items' : 'cart-items');
    if (!other?.getSectionsToRender) return () => {};
    const original = items.getSectionsToRender;
    const combined = [...original.call(items)];
    for (const section of other.getSectionsToRender()) {
      if (!combined.some(current => current.section === section.section)) combined.push(section);
    }
    if (combined.length > 5) return () => {};
    // Native updateQuantity renders these sections from its own response.
    // Its finally refresh of the other view would repeat the same request.
    items.getSectionsToRender = () => combined;
    items.secondCartItems = null;
    return () => { items.getSectionsToRender = original; items.secondCartItems = other; };
  }
  function includeOtherView(sections) {
    const combined = [...sections];
    const add = part => { if (!combined.some(existing => existing.section === part.section)) combined.push(part); };
    if (document.querySelector('cart-drawer-items')) add({id:'CartDrawer',section:'cart-drawer',selector:'.drawer__inner'});
    for (const part of pageSections()) add({id:part.selector.split(' ')[0].slice(1),section:part.id,selector:'.js-contents'});
    return combined;
  }
  document.addEventListener('keydown', () => { keyboardInteraction = true; }, true);
  document.addEventListener('pointerdown', () => { keyboardInteraction = false; }, true);
  const updateStickySavings = drawer => {
    const header = drawer?.querySelector('.drawer__header');
    const body = drawer?.querySelector('.cart-drawer__body');
    const summary = header?.querySelector('[data-cart-sticky-savings]');
    const milestone = body?.querySelector('[data-eligible-savings]');
    if (!header || !body || !summary) return;
    if (header.classList.contains('siss-bfcm-promo-header')) {
      header.classList.remove('siss-sticky-savings-active');
      summary.setAttribute('aria-hidden', 'true');
      return;
    }

    const amount = milestone?.querySelector('.eligible-savings__amount')?.textContent.trim() || '';
    const percent = Number(milestone?.dataset.currentPercent || 0);
    const bodyTop = body.getBoundingClientRect().top;
    const milestoneBottom = milestone?.getBoundingClientRect().bottom || bodyTop;
    const active = Boolean(
      drawer.classList.contains('active') &&
      milestone && !milestone.hidden &&
      amount &&
      Number.isFinite(percent) &&
      percent > 0 &&
      milestoneBottom <= bodyTop + 2
    );

    if (active) {
      summary.querySelector('[data-cart-sticky-savings-amount]').textContent = amount;
      summary.querySelector('[data-cart-sticky-savings-percent]').textContent = String(percent);
      const accent = getComputedStyle(milestone).getPropertyValue('--savings-accent').trim();
      if (accent) header.style.setProperty('--sticky-savings-accent', accent);
    }
    header.classList.toggle('siss-sticky-savings-active', active);
    summary.setAttribute('aria-hidden', String(!active));
  };
  const scheduleStickySavings = drawer => {
    if (!drawer || stickyFrames.has(drawer)) return;
    stickyFrames.set(drawer, requestAnimationFrame(() => {
      stickyFrames.delete(drawer);
      updateStickySavings(drawer);
    }));
  };
  document.addEventListener('sissilux:cart-display-updated',()=>document.querySelectorAll('cart-drawer').forEach(scheduleStickySavings));
  const bindStickySavings = drawer => {
    if (!drawer || drawer.sissStickySavingsBound) return;
    drawer.sissStickySavingsBound = true;
    const bindBody = () => {
      const body = drawer.querySelector('.cart-drawer__body');
      if (!body || body.sissStickySavingsBound) return;
      body.sissStickySavingsBound = true;
      body.addEventListener('scroll', () => scheduleStickySavings(drawer), {passive:true});
    };
    bindBody();
    new MutationObserver(() => scheduleStickySavings(drawer)).observe(drawer, {attributes:true, attributeFilter:['class']});
    drawer.sissBindStickySavingsBody = bindBody;
    scheduleStickySavings(drawer);
  };
  const quantityRequests = new WeakMap();
  const scrollRegions = ['.drawer__inner', '.cart-drawer__body'];
  const scrollAnchors = ['.cart-drawer-item', '[data-siss-warranty-block]', '.siss-promo-rewards__title',
    '.siss-promo-rewards__fixed-list', '.siss-promo-rewards__choice', '.siss-promo-rewards__card-bonus', '.siss-promo-rewards__add-on'];
  const anchorIdentity = node => node.classList.contains('cart-drawer-item')
    ? [...node.classList].find(name => name.startsWith('cart-item--product-')) + '|' + node.dataset.variantOptions
    : scrollAnchors.find(selector => node.matches(selector));
  const snapshot = drawer => {
    if (!drawer?.classList.contains('active')) return null;
    const regions = scrollRegions.map(selector => {
      const node = drawer.querySelector(selector);
      return {selector, top:node?.scrollTop || 0, left:node?.scrollLeft || 0};
    });
    const region = regions[0].top > 0 ? regions[0] : regions[1];
    const scroller = drawer.querySelector(region.selector);
    const edge = scroller?.getBoundingClientRect();
    const anchors = edge && region.top > 0 ? [...drawer.querySelectorAll(scrollAnchors.join(','))]
      .filter(node => { const rect = node.getBoundingClientRect(); return rect.height > 0 && rect.bottom > edge.top && rect.top < edge.bottom; })
      .map(node => ({key:anchorIdentity(node), offset:node.getBoundingClientRect().top - edge.top})) : [];
    return {regions, selector:region.selector, anchors};
  };
  const restore = (drawer, position) => {
    if (!position || !drawer?.classList.contains('active')) return;
    position.regions.forEach(region => {
      const node = drawer.querySelector(region.selector);
      if (node) { node.scrollTop = region.top; node.scrollLeft = region.left; }
    });
    const scroller = drawer.querySelector(position.selector);
    if (!scroller) return;
    const nodes = [...drawer.querySelectorAll(scrollAnchors.join(','))];
    // Keep the visible product/reward in place when an automatic add-on changes content above it.
    for (const anchor of position.anchors) {
      const node = nodes.find(candidate => anchorIdentity(candidate) === anchor.key && candidate.getBoundingClientRect().height > 0);
      if (!node) continue;
      scroller.scrollTop += node.getBoundingClientRect().top - scroller.getBoundingClientRect().top - anchor.offset;
      break;
    }
  };
  const preserveQuantityScroll = items => {
    const pending = quantityRequests.get(items);
    if (pending?.size !== 1) return;
    const request = pending.values().next().value;
    // Only a named keyboard edit needs native focus scrolling. Automatic gift
    // changes have no input name, even if an earlier action used the keyboard.
    if (request.keyboardNavigation && keyboardInteraction) return;
    const drawer = document.querySelector('cart-drawer');
    const position = snapshot(drawer);
    // Capture when the response renders, so scrolling during the request wins.
    // Restore after the native DOM replacement and first-product focus.
    queueMicrotask(() => restore(drawer, position));
  };
  customElements.whenDefined('cart-drawer').then(() => {
    const prototype = customElements.get('cart-drawer').prototype;
    if (prototype.sissScrollBound) return;
    prototype.sissScrollBound = true;
    // Lock the page itself, not just its scrollbar. The drawer owns vertical
    // scrolling; translated/hidden outer containers must never retain a pan.
    let pagePosition = null;
    const clearOuterPan = drawer => {
      drawer.scrollLeft = 0;
      const panel = drawer.querySelector('#CartDrawer');
      if (panel) panel.scrollLeft = 0;
    };
    const lockPage = drawer => {
      clearOuterPan(drawer);
      if (pagePosition !== null) return;
      pagePosition = window.scrollY;
      document.body.style.setProperty('--siss-cart-page-top', `${-pagePosition}px`);
      document.documentElement.classList.add('siss-cart-open');
      document.body.classList.add('siss-cart-open');
      document.documentElement.scrollLeft = 0;
    };
    const unlockPage = drawer => {
      clearOuterPan(drawer);
      if (pagePosition === null) return;
      const top = pagePosition;
      pagePosition = null;
      document.documentElement.classList.remove('siss-cart-open');
      document.body.classList.remove('siss-cart-open');
      document.body.style.removeProperty('--siss-cart-page-top');
      window.scrollTo({left: 0, top, behavior: 'instant'});
    };
    const nativeOpen = prototype.open;
    prototype.open = function(...args) {
      lockPage(this);
      return nativeOpen.apply(this, args);
    };
    const nativeClose = prototype.close;
    prototype.close = function(...args) {
      try { return nativeClose.apply(this, args); }
      finally { unlockPage(this); }
    };
    document.querySelectorAll('cart-drawer').forEach(drawer => {
      // The native constructor may already have bound its original close()
      // to the overlay. Observe only the host's open state to cover that path.
      let wasActive = drawer.classList.contains('active');
      const syncPageLock = () => {
        const active = drawer.classList.contains('active');
        if (active) lockPage(drawer);
        else if (wasActive) unlockPage(drawer);
        wasActive = active;
      };
      new MutationObserver(syncPageLock).observe(drawer, {attributes: true, attributeFilter: ['class']});
      if (drawer.classList.contains('active')) lockPage(drawer);
    });
    const nativeFix = window.fixParsedHtml;
    if (typeof nativeFix === 'function' && !nativeFix.sissProductMatched) {
      const matchedFix = function(previous, next) {
        const oldNodes = [...previous.querySelectorAll(toggleSelector)];
        const ordered = [...next.querySelectorAll(toggleSelector)].map(node => {
          // A settled quantity transaction already contains confirmed add-on
          // selections and warranty prices. Do not copy the previous quote back.
          if (quantityTransaction && (node.hasAttribute('data-siss-managed-addon') || node.hasAttribute('data-siss-warranty-native'))) return node;
          return oldNodes.find(old => old.tagName === node.tagName && old.dataset.handle === node.dataset.handle) || node;
        });
        return nativeFix({
          querySelector: selector => previous.querySelector(selector),
          querySelectorAll: selector => selector === toggleSelector ? ordered : previous.querySelectorAll(selector)
        }, next);
      };
      matchedFix.sissProductMatched = true;
      window.fixParsedHtml = matchedFix;
    }
    reconcileUpsells();
    const sections = prototype.getSectionsToRender;
    prototype.getSectionsToRender = function() {
      return [...sections.call(this), ...pageSections()];
    };
    const render = prototype.renderContents;
    prototype.renderContents = function(data, skipOpen) {
      viewRevision++;
      acceptAddonCart(data);
      queueNewUpsells(this, data.sections?.['cart-drawer']);
      const position = snapshot(this);
      const active = document.activeElement;
      const focusInside = this.contains(active);
      const focusId = focusInside ? active.id : '';
      // Extra page sections are requested with the mutation, but rendered by
      // renderPage so a null optional section cannot interrupt drawer rendering.
      const combined = this.getSectionsToRender;
      this.getSectionsToRender = () => sections.call(this);
      let result;
      try { result = render.call(this, data, Boolean(skipOpen || position)); }
      finally { this.getSectionsToRender = combined; }
      if (!renderPage(data.sections)) refreshPage().catch(console.error);
      reconcileUpsells();
      addPendingUpsell(this);
      scheduleDependentUpsellCleanup();
      scheduleManagedAddons();
      if (position && (focusInside || active === document.body) && typeof trapFocus === 'function') {
        const target = (focusId && document.getElementById(focusId)) || this.querySelector('.drawer__close');
        if (target) trapFocus(this.querySelector('.drawer__inner'), target);
      }
      restore(this, position);
      requestAnimationFrame(() => {
        restore(this, position);
        this.sissBindStickySavingsBody?.();
        scheduleStickySavings(this);
      });
      return result;
    };
    document.querySelectorAll('cart-drawer').forEach(bindStickySavings);
  });
  customElements.whenDefined('cart-drawer-items').then(() => {
    const prototype = customElements.get('cart-drawer-items').prototype;
    if (prototype.sissScrollBound) return;
    prototype.sissScrollBound = true;
    const update = prototype.updateQuantity;
    const ownSections = prototype.getSectionsToRender;
    prototype.getSectionsToRender = function() { return includeOtherView(ownSections.call(this)); };
    const renderSection = prototype.getSectionInnerHTML;
    const announce = prototype.updateLiveRegions;
    const requests = quantityRequests;
    prototype.getSectionInnerHTML = function(...args) {
      const pending = requests.get(this);
      if (args[1] === '.drawer__inner') preserveQuantityScroll(this);
      const html = renderSection.apply(this, args);
      if (pending?.size === 1) pending.values().next().value.rendered = true;
      return html;
    };
    prototype.updateLiveRegions = function(line, message) {
      const pending = requests.get(this);
      if (pending?.size === 1) {
        const request = pending.values().next().value;
        const template = window.cartStrings?.quantityError;
        if (request.rendered && String(line) === request.line && template &&
            Number.isSafeInteger(request.quantity) && request.quantity > 0 &&
            message === template.replace('[quantity]', String(request.quantity))) {
          message = '';
        }
      }
      return announce.call(this, line, message);
    };
    prototype.updateQuantity = async function(...args) {
      const giftCorrection = args[3]?.source === 'sissilux-gift' && window.__gptGiftControllerV2?.operationCount > 0;
      if (transactionEnabled() && !giftCorrection) return changeCartQuantity(this, ...args);
      const warranty = window.SissiluxWarranty;
      const coordinated = typeof warranty?.beginQuantity === 'function';
      if (coordinated && !warranty.beginQuantity(args[0])) return false;
      rememberAddonRemoval(args[0], args[1]);
      viewRevision++;
      const pending = requests.get(this) || new Set();
      const request = {line:String(args[0]), quantity:Number(args[1]), rendered:false,
        keyboardNavigation:Boolean(args[2]) && keyboardInteraction};
      pending.add(request);
      requests.set(this, pending);
      const restoreSections = bundleCartViews(this);
      try { return await update.apply(this, args); }
      finally {
        restoreSections();
        try {
          if (coordinated) await warranty.finishQuantity();
        } finally {
          pending.delete(request);
          if (!pending.size) requests.delete(this);
          reconcileUpsells();
        }
      }
    };
  });
  customElements.whenDefined('cart-items').then(() => {
    const prototype = customElements.get('cart-items').prototype;
    if (prototype.sissCombinedViewsBound) return;
    prototype.sissCombinedViewsBound = true;
    const ownSections = prototype.getSectionsToRender;
    prototype.getSectionsToRender = function() { return includeOtherView(ownSections.call(this)); };
    const sectionHTML = prototype.getSectionInnerHTML;
    prototype.getSectionInnerHTML = function(html,selector) {
      if (this.nodeName === 'CART-ITEMS' && selector === '.drawer__inner') {
        // On /cart, automatic tier corrections originate from the page instance.
        // Its request is distinct from the drawer instance receiving the HTML.
        preserveQuantityScroll(this);
        const drawerItems = document.querySelector('cart-drawer-items');
        if (drawerItems) return drawerItems.getSectionInnerHTML(html,selector);
      }
      return sectionHTML.call(this,html,selector);
    };
    const onCartUpdate = prototype.onCartUpdate;
    prototype.onCartUpdate = function() {
      if (!document.querySelector('cart-drawer')) return onCartUpdate.call(this);
      // Native publication and drawer rendering are synchronous. Consume their
      // bundled page sections instead of racing an items-only GET against them.
      queueMicrotask(() => {
        if (!renderPage(lastCartEvent?.cartData?.sections)) refreshPage().catch(console.error);
      });
    };
    const update = prototype.updateQuantity;
    prototype.updateQuantity = async function(...args) {
      // The drawer has its own wrapper above; only wrap the page instance.
      if (this.nodeName !== 'CART-ITEMS') return update.apply(this,args);
      const giftCorrection = args[3]?.source === 'sissilux-gift' && window.__gptGiftControllerV2?.operationCount > 0;
      if (transactionEnabled() && !giftCorrection) return changeCartQuantity(this, ...args);
      const warranty = window.SissiluxWarranty;
      if (warranty && !warranty.beginQuantity(args[0])) return false;
      rememberAddonRemoval(args[0], args[1]);
      viewRevision++;
      const pending = quantityRequests.get(this) || new Set();
      const request = {keyboardNavigation:Boolean(args[2]) && keyboardInteraction};
      pending.add(request);
      quantityRequests.set(this, pending);
      const restoreSections = bundleCartViews(this);
      try { return await update.apply(this,args); }
      finally {
        pending.delete(request);
        if (!pending.size) quantityRequests.delete(this);
        restoreSections(); warranty?.finishQuantity(); reconcileUpsells();
      }
    };
  });
  customElements.whenDefined('cart-drawer-upsell').then(() => {
    const prototype = customElements.get('cart-drawer-upsell').prototype;
    const updateId = prototype.updateId;
    prototype.updateId = function(id) {
      if (!this.hasAttribute('data-siss-managed-addon')) return updateId.call(this,id);
      this.dataset.id = String(id);
      if (this.idInput) this.idInput.value = String(id);
      if (this.dataset.selected === 'true') chooseManagedAddon(this.dataset.handle, true, id);
    };
    const toggle = prototype.handleToggle;
    prototype.handleToggle = function(event) {
      if (window.SissiluxWarranty?.busy || this.toggleBtn?.disabled) return;
      // These cached references can point to a previous drawer after a render.
      this.cartDrawer = document.querySelector('cart-drawer');
      this.cartItems = this.cartDrawer?.querySelector('cart-drawer-items');
      return toggle.call(this,event);
    };
    const remove = prototype.removeFromCart;
    prototype.removeFromCart = async function() {
      if (this.hasAttribute('data-siss-warranty-native')) return remove.call(this);
      const drawer = document.querySelector('cart-drawer');
      const items = drawer?.querySelector('cart-drawer-items');
      const row = drawer?.querySelector('.cart-item--product-'+this.dataset.handle);
      if (!row || !items) return;
      this.toggleBtn?.setAttribute('disabled','');
      try { await items.updateQuantity(row.dataset.index,0); }
      finally {
        const current = document.querySelector('cart-drawer');
        const replacement = [...current.querySelectorAll('cart-drawer-upsell')].find(el => el.dataset.handle === this.dataset.handle);
        if (replacement) {
          replacement.dataset.selected = String(Boolean(current.querySelector('.cart-item--product-'+this.dataset.handle)));
          replacement.toggleBtn?.removeAttribute('disabled');
        }
      }
    };
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sissilux-decision-interactor"] && !Shopify.designMode) return;
  try {
    
(function(){
 function start(scope=document){
  if(window.SissiluxDecisionInteractor){window.SissiluxDecisionInteractor.init(scope);return;}
  const root=scope.matches?.('[data-sdi-root]')?scope:scope.querySelector('[data-sdi-root]');
  if(!root||document.querySelector('script[data-sdi-runtime-loader]'))return;
  const script=document.createElement('script');script.src=root.dataset.sdiRuntimeUrl;script.async=true;script.dataset.sdiRuntimeLoader='';document.head.append(script);
 }
 start();document.addEventListener('shopify:section:load',e=>start(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sissilux-product-discovery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sissilux-product-discovery')) {
  customElements.define('sissilux-product-discovery', class extends HTMLElement {
    connectedCallback() {
      const list = this.querySelector('[data-pd-list]');
      const prev = this.querySelector('[data-pd-prev]');
      const next = this.querySelector('[data-pd-next]');
      if (!list || !prev || !next || this.cleanup) return;
      const update = () => { prev.disabled = list.scrollLeft < 2; next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2; };
      const move = direction => () => list.scrollBy({left: direction * Math.max(150, list.clientWidth * .75), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      const backward = move(-1), forward = move(1);
      prev.addEventListener('click', backward); next.addEventListener('click', forward); list.addEventListener('scroll', update, {passive:true});
      const refresh = () => {
        update();
        list.querySelectorAll('.sx-pd-offer').forEach(label => {
          const range = document.createRange();
          range.selectNodeContents(label);
          const style = getComputedStyle(label);
          const available = label.clientWidth - parseFloat(style.paddingLeft || 0) - parseFloat(style.paddingRight || 0);
          const overflow = Math.ceil(range.getBoundingClientRect().width - available);
          label.classList.toggle('sx-pd-offer--scroll', overflow > 1);
          if (overflow > 1) {
            label.style.setProperty('--sx-pd-label-travel', '-' + overflow + 'px');
            label.style.setProperty('--sx-pd-label-duration', Math.max(6, overflow / 16 + 4) + 's');
          }
        });
      };
      const observer = new ResizeObserver(refresh); observer.observe(list); refresh();
      document.fonts?.ready.then(() => { if (this.isConnected) refresh(); });
      this.cleanup = () => { observer.disconnect(); prev.removeEventListener('click', backward); next.removeEventListener('click', forward); list.removeEventListener('scroll', update); };
    }
    disconnectedCallback() { this.cleanup?.(); this.cleanup = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sissilux-scratch-play"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-sissilux-scratch-play]';
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const lines = (value) => String(value || '')
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter(Boolean);

    const choose = (items) => items[Math.floor(Math.random() * items.length)] || '';

    class SissiluxScratchPlay {
      constructor(root) {
        this.root = root;
        this.board = root.querySelector('[data-scratch-board]');
        this.prompt = root.querySelector('[data-scratch-prompt]');
        this.reaction = root.querySelector('[data-scratch-reaction]');
        this.reactionCopy = root.querySelector('[data-reaction-copy]');
        this.coin = root.querySelector('[data-lucky-coin]');
        this.cards = Array.from(root.querySelectorAll('[data-scratch-card]'));
        this.dots = Array.from(root.querySelectorAll('[data-attempt-dot]'));
        this.config = this.readConfig();
        this.state = {
          phase: 'ready',
          activeCard: null,
          activePointerId: null,
          attempts: 0,
          hasWon: false,
          timers: new Set()
        };
        this.boundCoinMove = this.moveCoin.bind(this);
        this.boundCoinLeave = this.hideCoin.bind(this);
        this.boundWindowBlur = this.releasePointer.bind(this);
        this.init();
      }

      readConfig() {
        const node = this.root.querySelector('[data-scratch-config]');
        const config = JSON.parse(node.textContent);
        config.reactionBankOne = lines(config.reactionBankOne);
        config.reactionBankTwo = lines(config.reactionBankTwo);
        config.reactionBankMore = lines(config.reactionBankMore);
        return config;
      }

      init() {
        this.root.dataset.scratchInitialized = 'true';
        this.cards.forEach((card) => this.initCard(card));
        this.root.addEventListener('pointermove', this.boundCoinMove, { passive: true });
        this.root.addEventListener('pointerleave', this.boundCoinLeave);
        window.addEventListener('blur', this.boundWindowBlur);
        this.updateDots();
        this.setPrompt(this.config.promptOne, true);
        requestAnimationFrame(() => this.cards.forEach((card) => this.paintSurface(card)));
      }

      initCard(card) {
        const canvas = card.querySelector('[data-scratch-surface]');
        const scratch = {
          canvas,
          context: canvas.getContext('2d', { willReadFrequently: false }),
          gridColumns: 28,
          gridRows: 22,
          scratched: new Uint8Array(28 * 22),
          scratchedCount: 0,
          pointerDown: false,
          lastPoint: null,
          outcome: null,
          revealed: false
        };
        card.sissiluxScratch = scratch;
        canvas.addEventListener('pointerdown', (event) => this.onPointerDown(event, card));
        canvas.addEventListener('pointermove', (event) => this.onPointerMove(event, card));
        canvas.addEventListener('pointerup', (event) => this.onPointerUp(event, card));
        canvas.addEventListener('pointercancel', (event) => this.onPointerUp(event, card));
        canvas.addEventListener('lostpointercapture', () => {
          scratch.pointerDown = false;
          scratch.lastPoint = null;
        });
        canvas.addEventListener('keydown', (event) => this.onKeyDown(event, card));
      }

      paintSurface(card) {
        const { canvas, context } = card.sissiluxScratch;
        const rect = canvas.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        const ratio = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = Math.max(1, Math.round(rect.width * ratio));
        canvas.height = Math.max(1, Math.round(rect.height * ratio));
        context.globalCompositeOperation = 'source-over';
        const gradient = context.createLinearGradient(0, 0, canvas.width, canvas.height);
        gradient.addColorStop(0, '#8f867d');
        gradient.addColorStop(0.2, '#eee7dc');
        gradient.addColorStop(0.42, '#a99e93');
        gradient.addColorStop(0.62, '#f6efe5');
        gradient.addColorStop(0.82, '#aaa096');
        gradient.addColorStop(1, '#d9d0c5');
        context.fillStyle = gradient;
        context.fillRect(0, 0, canvas.width, canvas.height);
        context.save();
        context.globalAlpha = 0.17;
        context.strokeStyle = '#4d4640';
        context.lineWidth = Math.max(1, ratio);
        const spacing = Math.max(12, Math.round(18 * ratio));
        for (let offset = -canvas.height; offset < canvas.width; offset += spacing) {
          context.beginPath();
          context.moveTo(offset, 0);
          context.lineTo(offset + canvas.height, canvas.height);
          context.stroke();
        }
        context.restore();
        context.save();
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        context.fillStyle = 'rgba(70, 58, 48, 0.64)';
        context.font = `900 ${Math.round(canvas.height * 0.27)}px Arial, sans-serif`;
        context.fillText('S', canvas.width / 2, canvas.height * 0.43);
        context.font = `800 ${Math.max(8, Math.round(canvas.height * 0.07))}px Arial, sans-serif`;
        context.letterSpacing = `${Math.max(1, ratio)}px`;
        context.fillText('SISSILUX', canvas.width / 2, canvas.height * 0.68);
        context.restore();
      }

      onPointerDown(event, card) {
        const scratch = card.sissiluxScratch;
        if (scratch.revealed || this.state.phase === 'complete' || this.state.phase === 'reacting') return;
        if (this.state.activeCard && this.state.activeCard !== card) return;
        if (!this.state.activeCard) this.beginScratch(card);
        if (this.state.activeCard !== card) return;
        event.preventDefault();
        scratch.pointerDown = true;
        scratch.lastPoint = null;
        this.state.activePointerId = event.pointerId;
        scratch.canvas.setPointerCapture(event.pointerId);
        this.coin.classList.add('is-pressed');
        this.scratchAt(event, card);
      }

      onPointerMove(event, card) {
        const scratch = card.sissiluxScratch;
        if (!scratch.pointerDown || this.state.activeCard !== card || event.pointerId !== this.state.activePointerId) return;
        event.preventDefault();
        this.scratchAt(event, card);
      }

      onPointerUp(event, card) {
        const scratch = card.sissiluxScratch;
        if (event.pointerId !== this.state.activePointerId) return;
        scratch.pointerDown = false;
        scratch.lastPoint = null;
        this.state.activePointerId = null;
        this.coin.classList.remove('is-pressed');
        if (scratch.canvas.hasPointerCapture(event.pointerId)) scratch.canvas.releasePointerCapture(event.pointerId);
      }

      onKeyDown(event, card) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        if (card.sissiluxScratch.revealed || this.state.phase === 'complete' || this.state.phase === 'reacting') return;
        if (this.state.activeCard && this.state.activeCard !== card) return;
        if (!this.state.activeCard) this.beginScratch(card);
        if (this.state.activeCard === card) this.reveal(card);
      }

      beginScratch(card) {
        if (this.state.attempts >= this.config.maxScratches) return;
        const attemptIndex = this.state.attempts;
        const finalAttempt = attemptIndex === this.config.maxScratches - 1 && !this.state.hasWon;
        const earlyWin = Math.random() * 100 < this.config.earlyWinChance;
        const isWin = finalAttempt || earlyWin;
        const bank = attemptIndex === 0
          ? this.config.reactionBankOne
          : attemptIndex === 1
            ? this.config.reactionBankTwo
            : this.config.reactionBankMore;
        card.sissiluxScratch.outcome = {
          isWin,
          copy: isWin ? this.config.rewardText : choose(bank),
          kicker: isWin ? this.config.winKicker : this.config.missKicker
        };
        card.querySelector('[data-result-kicker]').textContent = card.sissiluxScratch.outcome.kicker;
        card.querySelector('[data-result-copy]').textContent = card.sissiluxScratch.outcome.copy;
        this.state.phase = 'scratching';
        this.state.activeCard = card;
        this.board.classList.add('is-locked');
        this.cards.forEach((candidate) => {
          const active = candidate === card;
          candidate.classList.toggle('is-active', active);
          const surface = candidate.querySelector('[data-scratch-surface]');
          surface.setAttribute('aria-disabled', active ? 'false' : 'true');
          if (!active) surface.tabIndex = -1;
        });
        this.setPrompt(this.config.scratchPrompt);
        this.hideReaction();
      }

      scratchAt(event, card) {
        const scratch = card.sissiluxScratch;
        const rect = scratch.canvas.getBoundingClientRect();
        const point = {
          x: event.clientX - rect.left,
          y: event.clientY - rect.top
        };
        const radius = Math.max(15, Math.min(rect.width, rect.height) * 0.145);
        const previous = scratch.lastPoint || point;
        const distance = Math.hypot(point.x - previous.x, point.y - previous.y);
        const steps = Math.max(1, Math.ceil(distance / Math.max(4, radius * 0.28)));
        for (let step = 0; step <= steps; step += 1) {
          const progress = step / steps;
          const x = previous.x + (point.x - previous.x) * progress;
          const y = previous.y + (point.y - previous.y) * progress;
          this.eraseCircle(scratch, rect, x, y, radius);
          this.markGrid(scratch, rect, x, y, radius);
        }
        scratch.lastPoint = point;
        const percent = scratch.scratchedCount / scratch.scratched.length * 100;
        scratch.canvas.setAttribute('aria-label', `Scratch card ${Number(card.dataset.cardIndex) + 1}, ${Math.round(percent)} percent scratched`);
        if (percent >= this.config.revealThreshold) this.reveal(card);
      }

      eraseCircle(scratch, rect, x, y, radius) {
        const scaleX = scratch.canvas.width / rect.width;
        const scaleY = scratch.canvas.height / rect.height;
        scratch.context.save();
        scratch.context.globalCompositeOperation = 'destination-out';
        scratch.context.beginPath();
        scratch.context.arc(x * scaleX, y * scaleY, radius * Math.max(scaleX, scaleY), 0, Math.PI * 2);
        scratch.context.fill();
        scratch.context.restore();
      }

      markGrid(scratch, rect, x, y, radius) {
        const cellWidth = rect.width / scratch.gridColumns;
        const cellHeight = rect.height / scratch.gridRows;
        const minColumn = Math.max(0, Math.floor((x - radius) / cellWidth));
        const maxColumn = Math.min(scratch.gridColumns - 1, Math.ceil((x + radius) / cellWidth));
        const minRow = Math.max(0, Math.floor((y - radius) / cellHeight));
        const maxRow = Math.min(scratch.gridRows - 1, Math.ceil((y + radius) / cellHeight));
        for (let row = minRow; row <= maxRow; row += 1) {
          for (let column = minColumn; column <= maxColumn; column += 1) {
            const centerX = (column + 0.5) * cellWidth;
            const centerY = (row + 0.5) * cellHeight;
            if (Math.hypot(centerX - x, centerY - y) > radius) continue;
            const index = row * scratch.gridColumns + column;
            if (scratch.scratched[index]) continue;
            scratch.scratched[index] = 1;
            scratch.scratchedCount += 1;
          }
        }
      }

      reveal(card) {
        const scratch = card.sissiluxScratch;
        if (scratch.revealed || this.state.phase === 'reacting') return;
        scratch.revealed = true;
        scratch.pointerDown = false;
        this.state.activePointerId = null;
        this.state.phase = 'reacting';
        this.coin.classList.remove('is-pressed');
        const outcome = scratch.outcome;
        const commitReveal = () => {
          card.classList.add('is-revealed');
          card.classList.toggle('is-win', outcome.isWin);
          card.querySelector('[data-card-result]').setAttribute('aria-hidden', 'false');
          scratch.canvas.classList.add('is-clearing');
          scratch.canvas.setAttribute('aria-disabled', 'true');
          scratch.canvas.tabIndex = -1;
        };
        if (document.startViewTransition && !reducedMotion.matches) {
          card.style.viewTransitionName = 'sl-scratch-card-reveal';
          const transition = document.startViewTransition(commitReveal);
          transition.finished.finally(() => card.style.removeProperty('view-transition-name'));
        } else {
          commitReveal();
        }
        this.state.attempts += 1;
        this.updateDots();
        this.schedule(() => {
          this.showReaction(outcome.isWin ? this.config.winReaction : outcome.copy, outcome.isWin);
        }, 420);
        if (outcome.isWin) {
          this.state.hasWon = true;
          this.state.phase = 'complete';
          this.setPrompt(this.config.winReaction);
          this.cards.forEach((candidate) => {
            candidate.classList.remove('is-active');
            const surface = candidate.querySelector('[data-scratch-surface]');
            surface.setAttribute('aria-disabled', 'true');
            surface.tabIndex = -1;
          });
          return;
        }
        this.schedule(() => this.unlockNext(card), this.config.reactionDelay);
      }

      unlockNext(card) {
        card.classList.remove('is-active');
        this.state.activeCard = null;
        this.state.phase = 'ready';
        this.board.classList.remove('is-locked');
        this.cards.forEach((candidate) => {
          if (candidate.sissiluxScratch.revealed) return;
          const surface = candidate.querySelector('[data-scratch-surface]');
          surface.setAttribute('aria-disabled', 'false');
          surface.tabIndex = 0;
        });
        const remaining = this.config.maxScratches - this.state.attempts;
        if (remaining === 1) {
          this.setPrompt(this.config.promptFinal);
        } else if (this.state.attempts === 1) {
          this.setPrompt(this.config.promptTwo);
        } else {
          this.setPrompt(this.config.promptContinue);
        }
      }

      updateDots() {
        this.dots.forEach((dot, index) => {
          dot.classList.toggle('is-hidden', index >= this.config.maxScratches);
          dot.classList.toggle('is-used', index < this.state.attempts);
        });
      }

      setPrompt(copy, immediate = false) {
        if (immediate) {
          this.prompt.textContent = copy;
          return;
        }
        this.prompt.classList.add('is-changing');
        this.schedule(() => {
          this.prompt.textContent = copy;
          this.prompt.classList.remove('is-changing');
        }, 160);
      }

      showReaction(copy, isWin) {
        this.reactionCopy.textContent = copy;
        this.reaction.classList.toggle('is-win', isWin);
        this.reaction.classList.add('is-visible');
      }

      hideReaction() {
        this.reaction.classList.remove('is-visible', 'is-win');
      }

      moveCoin(event) {
        if (!finePointer.matches) return;
        const surface = event.target.closest('[data-scratch-surface]');
        const card = surface && surface.closest('[data-scratch-card]');
        const usable = surface && card && !card.sissiluxScratch.revealed && this.state.phase !== 'reacting' && this.state.phase !== 'complete';
        if (!usable || this.state.activeCard && this.state.activeCard !== card) {
          this.hideCoin();
          return;
        }
        this.coin.classList.add('is-visible');
        this.coin.style.transform = `translate3d(${event.clientX - 28}px, ${event.clientY - 28}px, 0) rotate(-12deg)`;
      }

      hideCoin() {
        this.coin.classList.remove('is-visible', 'is-pressed');
      }

      releasePointer() {
        if (!this.state.activeCard) return;
        const scratch = this.state.activeCard.sissiluxScratch;
        scratch.pointerDown = false;
        scratch.lastPoint = null;
        this.state.activePointerId = null;
        this.coin.classList.remove('is-pressed');
      }

      schedule(callback, delay) {
        const timer = window.setTimeout(() => {
          this.state.timers.delete(timer);
          callback();
        }, delay);
        this.state.timers.add(timer);
      }

      destroy() {
        this.state.timers.forEach((timer) => window.clearTimeout(timer));
        this.state.timers.clear();
        this.root.removeEventListener('pointermove', this.boundCoinMove);
        this.root.removeEventListener('pointerleave', this.boundCoinLeave);
        window.removeEventListener('blur', this.boundWindowBlur);
        this.root.dataset.scratchInitialized = 'false';
      }
    }

    const initWithin = (scope = document) => {
      const roots = scope.matches && scope.matches(selector)
        ? [scope]
        : Array.from(scope.querySelectorAll(selector));
      roots.forEach((root) => {
        if (root.dataset.scratchInitialized === 'true') return;
        root.sissiluxScratchPlay = new SissiluxScratchPlay(root);
      });
    };

    const boot = () => initWithin(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.matches(selector) ? event.target : event.target.querySelector(selector);
      if (root && root.sissiluxScratchPlay) root.sissiluxScratchPlay.destroy();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sissilux-session-builder"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('sissilux-session-builder')) return;

  const safeUrl = (value, origin = location.origin) => {
    try {
      const url = new URL(value, origin);
      return url.protocol === 'https:' || url.origin === origin ? url.href : null;
    } catch { return null; }
  };
  const range = (value) => Array.isArray(value) ? value.join('–') : String(value ?? '');
  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined && text !== null) node.textContent = String(text);
    return node;
  };
  const goalIconPaths = [
    'M10 3l2.1 5.9L18 11l-5.9 2.1L10 19l-2.1-5.9L2 11l5.9-2.1L10 3zM19 2v5m-2.5-2.5h5M20 17v4m-2-2h4',
    'M20 3c-7 0-13 2-13 8a6 6 0 0 0 6 6c6 0 7-7 7-14zM4 21l11-11',
    'M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0M12 2v2m0 16v2M2 12h2m16 0h2M4.9 4.9l1.4 1.4m11.4 11.4 1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4',
    'M13 2 4 14h7l-1 8 10-13h-7l0-7z',
    'M3 6c3-4 6 4 9 0s6 4 9 0M3 12c3-4 6 4 9 0s6 4 9 0M3 18c3-4 6 4 9 0s6 4 9 0',
    'M20.5 13.5A8.5 8.5 0 0 1 10.5 3.5 8.5 8.5 0 1 0 20.5 13.5zM18 3v4m-2-2h4'
  ];
  const goalIcon = (index) => {
    const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    for (const [name, value] of Object.entries({class:'sb-goal-icon',viewBox:'0 0 24 24',fill:'none',stroke:'currentColor','stroke-width':'1.6','stroke-linecap':'round','stroke-linejoin':'round','aria-hidden':'true',focusable:'false'})) icon.setAttribute(name,value);
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d',goalIconPaths[index % goalIconPaths.length]);
    icon.append(path);
    return icon;
  };

  class SessionBuilder extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.timers = new Set();
      this.observers = [];
      this.exposures = new Set();
      this.seenEventKeys = new Set();
      this.eventLog = [];
      this.sessionId = typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      this.goal = null;
      this.branch = null;
      this.optionId = null;
      this.stage = 'goal';
      this.coverageId = null;
      this.resultVisit = 0;
      try {
        let config = JSON.parse(this.querySelector('[data-sb-config]').textContent);
        if (typeof config === 'string') config = JSON.parse(config);
        this.config = this.validateConfig(config);
        this.labels = JSON.parse(this.querySelector('[data-sb-labels]').textContent);
        this.products = JSON.parse(this.querySelector('[data-sb-products]').textContent);
        this.canvas = this.querySelector('[data-sb-canvas]');
        this.heading = this.querySelector('[data-sb-heading]');
        this.heading.textContent = this.config.section.title;
        this.querySelector('[data-sb-eyebrow]').textContent = this.config.section.eyebrow || this.labels.eyebrow;
        this.querySelector('[data-sb-subtitle]').textContent = this.config.section.subtitle || this.labels.subtitle;
        this.querySelector('[data-sb-fallback]').hidden = true;
        this.canvas.hidden = false;
        this.dataset.configVersion = this.config.config_version;
        this.dataset.schemaVersion = this.config.schema_version;
        this.addEventListener('click', (event) => this.handleClick(event), { signal: this.abort.signal });
        this.addEventListener('change', (event) => this.handleChange(event), { signal: this.abort.signal });
        document.addEventListener('sissilux:session-commercial', (event) => this.commercial(event.detail), { signal: this.abort.signal });
        document.addEventListener('visitorConsentCollected', () => this.reobserve(), { signal: this.abort.signal });
        this.render();
      } catch (error) {
        this.dataset.state = 'unavailable';
        if (this.dataset.designMode === 'true') {
          const report = this.querySelector('[data-sb-editor-error]');
          if (report) { report.hidden = false; report.textContent = error.message; }
        } else { this.hidden = true; }
      }
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.renderAbort?.abort();
      this.abort = null;
      this.disconnectObservers();
      this.timers?.forEach(clearTimeout);
      this.eventLog = [];
    }

    validateConfig(config) {
      if (!['1.7','1.8'].includes(config?.schema_version)) throw new Error('This renderer supports schema 1.7 or 1.8.');
      if (!config.config_version || !config.product?.id || !Array.isArray(config.goals) || !config.goals.length) throw new Error('Missing product configuration or goals.');
      if (!Array.isArray(config.session_templates) || !config.section) throw new Error('Missing session templates or section configuration.');
      if (!Array.isArray(config.section.result_card_order)) {
        if (config.schema_version === '1.7') throw new Error('Missing result order.');
        config.section.result_card_order = ['summary','timing','session','supporting_action','routine_fit','tracking_metric','trial_period','good_to_know'];
      }
      const templateIds = new Set(config.session_templates.map(t => t.id));
      const allIds = new Set();
      for (const goal of config.goals) {
        if (!goal.id || allIds.has(goal.id) || !goal.branches?.length) throw new Error('Invalid or duplicate goal.');
        allIds.add(goal.id);
        const branches = new Set(goal.branches.map(b => b.id));
        if (goal.follow_up) {
          if (!goal.follow_up.options?.length || goal.follow_up.options.some(o => !branches.has(o.branch_id))) throw new Error('Unreachable answer branch.');
          if (goal.branches.some(b => !goal.follow_up.options.some(o => o.branch_id === b.id))) throw new Error('Unreachable result.');
        } else if (goal.branches.length !== 1) throw new Error('Direct goals must have one result.');
        for (const branch of goal.branches) {
          if (allIds.has(branch.id) || !templateIds.has(branch.session_template_id)) throw new Error('Duplicate branch or missing template.');
          allIds.add(branch.id);
          if (!['launch', 'launch_with_boundaries'].includes(branch.launch_disposition)) throw new Error('Unreleased branch in published configuration.');
          if (branch.cross_sell_rule !== null && branch.cross_sell_rule !== undefined) throw new Error('Use top-level coverage routing only.');
          if (branch.supporting_action && (Array.isArray(branch.supporting_action) || !branch.supporting_action.instruction)) throw new Error('Only one supporting action is supported.');
        }
      }
      const allowedOrder = ['summary','timing','session','supporting_action','routine_fit','tracking_metric','trial_period','good_to_know'];
      if (config.section.result_card_order.some(k => !allowedOrder.includes(k)) || new Set(config.section.result_card_order).size !== config.section.result_card_order.length) throw new Error('Invalid result card order.');
      const coverage = config.coverage_extension;
      const coverageRelationships = config.schema_version === '1.8' ? ['none','add_on','same_product_repositioned','second_unit'] : ['none','add_on'];
      if (coverage?.enabled && (coverage.placement !== 'after_primary_result' || coverage.selection_mode !== 'single' || !coverage.options?.length || coverage.options.some(o => !coverageRelationships.includes(o.relationship)))) throw new Error('Unsupported coverage routing.');
      if (coverage?.enabled && config.schema_version === '1.7' && coverage.counts_as_builder_stage !== false) throw new Error('Unsupported coverage stage.');
      if (coverage?.enabled && config.schema_version === '1.8' && coverage.option_visibility === 'filter_by_selected_goal_id' && coverage.options.some(o => !Array.isArray(o.eligible_goal_ids) || !o.eligible_goal_ids.length)) throw new Error('Missing goal eligibility for coverage option.');
      return config;
    }

    resolved(branch = this.branch) {
      const template = this.config.session_templates.find(item => item.id === branch.session_template_id);
      const session = { ...template, ...branch };
      session.duration_minutes = branch.duration?.value ?? template.duration_minutes;
      session.max_sessions_per_day = branch.max_sessions_per_day ?? branch.max_sessions_per_selected_area_per_day ?? template.max_sessions_per_day ?? template.max_sessions_per_selected_area_per_day;
      session.good_to_know = branch.good_to_know ?? (session.parameter_basis === 'product_inferred' ? template.brightness_policy : branch.supporting_advice);
      return session;
    }

    button(label, action, value, className = 'sb-button') {
      const button = element('button', className, label);
      button.type = 'button';
      button.dataset.action = action;
      if (value !== undefined) button.dataset.value = value;
      return button;
    }

    handleClick(event) {
      const button = event.target.closest('[data-action]');
      if (!button || button.closest('sissilux-session-builder') !== this) return;
      const { action, value } = button.dataset;
      if (action === 'goal') {
        this.goal = this.config.goals.find(g => g.id === value);
        if (!this.goal) return;
        this.branch = null;
        this.optionId = null;
        this.coverageId = null;
        this.emit('session_goal_selected', { display_order: this.goal.display_order });
        if (this.goal.follow_up) this.stage = 'modifier';
        else { this.branch = this.goal.branches[0]; this.stage = 'result'; this.resultVisit++; }
        this.render(true);
      } else if (action === 'modifier') {
        const option = this.goal.follow_up.options.find(o => o.id === value);
        if (!option) return;
        this.optionId = option.id;
        this.emit('session_modifier_selected', { option_id: option.id });
        this.branch = this.goal.branches.find(b => b.id === option.branch_id);
        this.coverageId = null;
        this.stage = 'result';
        this.resultVisit++;
        this.render(true);
      } else if (action === 'back') {
        this.stage = this.stage === 'result' && this.goal.follow_up ? 'modifier' : 'goal';
        this.branch = null;
        this.coverageId = null;
        this.render(true);
      } else if (action === 'restart') {
        this.stage = 'goal'; this.branch = null; this.optionId = null; this.coverageId = null;
        this.render(true);
      } else if (action === 'tip-prev' || action === 'tip-next') {
        this.moveTip(this.tipIndex + (action === 'tip-next' ? 1 : -1));
      } else if (action === 'related') {
        const option = this.config.coverage_extension.options.find(o => o.id === this.coverageId);
        if (option) this.emit('session_related_product_clicked', { coverage_option_id: option.id, recommended_product_key: option.recommended_product_key });
      }
    }

    handleChange(event) {
      if (!event.target.matches('[data-sb-coverage-option]') || this.stage !== 'result') return;
      const option = this.coverageOptions().find(o => o.id === event.target.value);
      if (!option) return;
      this.coverageId = option.id;
      this.emit('session_coverage_extension_selected', { coverage_option_id: option.id, recommended_product_key: option.recommended_product_key, relationship: option.relationship });
      this.renderRelated();
    }

    render(moveFocus = false) {
      this.renderAbort?.abort();
      this.renderAbort = new AbortController();
      this.disconnectObservers();
      this.timers.forEach(clearTimeout); this.timers.clear();
      this.canvas.replaceChildren();
      this.tips = null;
      this.tipIndex = 0;
      this.dataset.state = this.stage;
      const progress = element('ol', 'sb-progress');
      progress.setAttribute('aria-label', this.labels.progress);
      const hasModifier = this.stage === 'goal' ? this.config.goals.some(goal => goal.follow_up) : Boolean(this.goal?.follow_up);
      const stages = hasModifier ? ['goal','modifier','result'] : ['goal','result'];
      stages.forEach((stage, i) => {
        const li = element('li', '', `${String(i + 1).padStart(2,'0')}  ${this.labels[stage]}`);
        if (stage === this.stage) li.setAttribute('aria-current', 'step');
        progress.append(li);
      });
      this.canvas.append(progress);
      if (this.stage !== 'goal') {
        const nav = element('div', 'sb-nav');
        nav.append(this.button(`← ${this.labels.back}`, 'back', undefined, 'sb-text-button'));
        if (this.stage === 'result') nav.append(this.button(this.labels.change_goal, 'restart', undefined, 'sb-text-button'));
        this.canvas.append(nav);
      }
      if (this.stage === 'goal') this.renderGoals();
      else if (this.stage === 'modifier') this.renderModifier();
      else this.renderResult();
      this.reobserve();
      if (moveFocus) {
        const title = this.canvas.querySelector('[data-sb-focus]');
        title?.focus({ preventScroll: true });
        if (title && (title.getBoundingClientRect().top < 110 || title.getBoundingClientRect().top > innerHeight * .7)) title.scrollIntoView({ block:'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
    }

    focusTitle(text, parent) {
      const title = element('h3', 'sb-stage-title', text);
      title.tabIndex = -1; title.dataset.sbFocus = '';
      parent.append(title); return title;
    }

    renderGoals() {
      this.focusTitle(this.labels.choose_goal, this.canvas);
      this.canvas.append(element('p','sb-muted',this.labels.goal_hint));
      const grid = element('div','sb-goals');
      [...this.config.goals].sort((a,b) => a.display_order - b.display_order).forEach((goal, index) => {
        const button = this.button('', 'goal', goal.id, 'sb-goal');
        button.dataset.goalId = goal.id;
        button.setAttribute('aria-pressed', String(this.goal?.id === goal.id));
        button.append(element('span','sb-goal-title',goal.primary_label || goal.title), element('span','sb-muted',goal.supporting_symptom_label), goalIcon(index));
        grid.append(button);
      });
      this.canvas.append(grid, element('p','sb-footnote',this.labels.no_email));
    }

    renderModifier() {
      this.canvas.append(element('p','sb-eyebrow',this.goal.primary_label || this.goal.title));
      this.focusTitle(this.goal.follow_up.question, this.canvas);
      const choices = element('div','sb-answers');
      this.goal.follow_up.options.forEach(option => {
        const button = this.button(option.label, 'modifier', option.id, 'sb-goal sb-answer');
        button.setAttribute('aria-pressed', String(this.optionId === option.id));
        choices.append(button);
      });
      this.canvas.append(choices);
    }

    field(parent, key, text, className = '') {
      if (!text) return;
      const item = element('div', `sb-field ${className}`);
      item.dataset.resultField = key;
      item.append(element('h4','sb-label',this.labels[key]), element('p','',text));
      parent.append(item); return item;
    }

    renderResult() {
      const session = this.resolved();
      const result = element('article','sb-result');
      result.dataset.sbResult = '';
      result.dataset.branchId = this.branch.id;
      const header = element('header','sb-result-header');
      header.append(element('p','sb-eyebrow',this.labels.your_plan));
      this.focusTitle(session.result_title || this.goal.primary_label || this.goal.title, header);
      if (this.optionId) header.append(element('p','sb-result-pattern',this.goal.follow_up.options.find(o => o.id === this.optionId)?.label));
      result.append(header);
      const primary = element('div','sb-primary');
      this.renderSession(primary, session);
      if (session.supporting_action?.instruction) this.field(primary,'supporting_action',session.supporting_action.instruction,'sb-pair');
      else primary.classList.add('sb-primary-solo');
      result.append(primary);
      if (session.safety_note) {
        const note = element('p','sb-safety',session.safety_note);
        note.prepend(element('strong','',`${this.labels.safety} `));
        result.append(note);
      }
      this.renderTips(result, session);
      this.canvas.append(result);
      if (this.config.coverage_extension?.enabled && this.dataset.coverageEnabled === 'true') this.renderCoverage();
      this.renderLearnMore(session);
    }

    renderTips(parent, session) {
      const keys = this.config.section.result_card_order.filter(key => ['routine_fit','tracking_metric','trial_period'].includes(key) && session[key]);
      if (!keys.length) return;
      const region = element('section','sb-tips');
      const header = element('div','sb-tips-header');
      const title = element('h4','sb-tips-title',this.labels.routine_tips);
      const track = element('div','sb-tips-track');
      track.id = `SessionTips-${this.dataset.sectionId}`;
      track.setAttribute('role','region');
      track.setAttribute('aria-label',this.labels.routine_tips);
      const controls = element('div','sb-tips-controls');
      const previous = this.button('←','tip-prev',undefined,'sb-tip-button');
      const next = this.button('→','tip-next',undefined,'sb-tip-button');
      previous.setAttribute('aria-label',this.labels.previous_tip);
      next.setAttribute('aria-label',this.labels.next_tip);
      previous.setAttribute('aria-controls',track.id); next.setAttribute('aria-controls',track.id);
      const counter = element('span','sb-tip-count');
      counter.setAttribute('aria-live','polite'); counter.setAttribute('aria-atomic','true');
      controls.append(previous,counter,next); header.append(title,controls);
      keys.forEach(key => this.field(track,key,session[key],'sb-tip-card'));
      region.append(header,track); parent.append(region);
      this.tipIndex = 0;
      const media = matchMedia('(max-width: 749px)');
      const sync = () => {
        controls.hidden = !media.matches || keys.length < 2;
        track.tabIndex = media.matches && keys.length > 1 ? 0 : -1;
        this.updateTips();
      };
      media.addEventListener?.('change',sync,{signal:this.renderAbort.signal});
      track.addEventListener('scroll',() => {
        const boxes = [...track.children].map(node => node.getBoundingClientRect());
        const edge = track.getBoundingClientRect().left;
        const nearest = boxes.reduce((best,box,index) => Math.abs(box.left-edge) < Math.abs(boxes[best].left-edge) ? index : best,0);
        if (this.tipIndex !== nearest) { this.tipIndex = nearest; this.updateTips(); }
      },{passive:true,signal:this.renderAbort.signal});
      track.addEventListener('keydown',event => {
        if (!media.matches || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        this.moveTip(event.key === 'Home' ? 0 : event.key === 'End' ? keys.length - 1 : this.tipIndex + (event.key === 'ArrowRight' ? 1 : -1));
      },{signal:this.renderAbort.signal});
      this.tips = {track,previous,next,counter,count:keys.length};
      sync();
    }

    updateTips() {
      if (!this.tips) return;
      const {previous,next,counter,count} = this.tips;
      previous.setAttribute('aria-disabled',String(this.tipIndex === 0));
      next.setAttribute('aria-disabled',String(this.tipIndex === count - 1));
      counter.textContent = `${this.tipIndex + 1} / ${count}`;
    }

    moveTip(index) {
      if (!this.tips) return;
      const {track,count} = this.tips;
      this.tipIndex = Math.max(0,Math.min(count - 1,index));
      const left = track.children[this.tipIndex].offsetLeft - track.children[0].offsetLeft;
      track.scrollTo({left,behavior:'instant'});
      this.updateTips();
    }

    scheduleDetail(session) {
      const normalize = value => String(value || '').replace(/[–—]/g,'-').trim();
      let text = normalize(session.frequency);
      const prefix = `${normalize(range(session.frequency_per_week))} times per week`;
      const suffix = `maximum ${session.max_sessions_per_day} session${session.max_sessions_per_day === 1 ? '' : 's'} per day`;
      if (text.startsWith(prefix)) text = text.slice(prefix.length).trim();
      if (text.endsWith(suffix)) text = text.slice(0,-suffix.length).replace(/;\s*$/,'').trim();
      return text ? text[0].toUpperCase() + text.slice(1) : '';
    }

    renderSession(parent, session) {
      const card = element('div','sb-session'); card.dataset.resultField = 'session';
      this.field(card,'timing',session.timing,'sb-timing');
      const metrics = element('dl','sb-metrics');
      const values = [
        [this.labels.duration, range(session.duration_minutes), this.labels.minutes],
        [this.labels.frequency, range(session.frequency_per_week), this.labels.times_week],
        [this.labels.limit, range(session.max_sessions_per_day), this.labels.max_day]
      ];
      values.forEach(([label,value,unit]) => {
        if (!value) return;
        const group = element('div');
        const dd = element('dd'); dd.append(element('strong','',value), element('span','',unit));
        group.append(element('dt','',label),dd); metrics.append(group);
      });
      card.append(metrics);
      const schedule = this.scheduleDetail(session);
      if (schedule) card.append(element('p','sb-schedule',schedule));
      if (session.progression && !/progress within/i.test(session.frequency || '')) card.append(element('p','sb-progression',session.progression));
      const settings = element('div','sb-settings');
      if (session.brightness_policy) settings.append(element('p','sb-setting',session.brightness_policy.replace('; irradiance by brightness remains an internal measurement gap.','.')));
      if (session.mode_policy) settings.append(element('p','sb-setting',/^(Use a continuous light mode[.;]|Continuous light only;)/.test(session.mode_policy) ? this.labels.continuous_mode : session.mode_policy));
      card.append(settings);
      if (session.parameter_basis === 'product_inferred' && this.config.schema_version === '1.7') {
        const boundary = element('div','sb-boundary');
        boundary.append(element('strong','',this.labels.inferred), element('p','',this.labels.inferred_boundary));
        card.append(boundary);
      }
      parent.append(card);
    }

    renderLearnMore(session) {
      const details = element('details','sb-details sb-learn');
      details.append(element('summary','',this.labels.learn_more));
      const content = element('div','sb-details-body');
      this.field(content,'summary',session.summary,'sb-summary');
      this.field(content,'good_to_know',session.good_to_know);
      this.field(content,'why_fits',session.why_this_product_fits);
      if (this.config.schema_version === '1.7') {
        this.field(content,'evidence',session.evidence?.explanation);
        if (session.evidence) content.append(element('p','sb-footnote',`${this.labels.evidence_status}: ${session.evidence.evidence_status} · ${this.labels.transfer}: ${session.evidence.transfer_confidence}`));
        this.field(content,'pair_reason',session.supporting_action?.why);
        if (session.estimated_fluence_j_cm2 && session.parameter_basis !== 'product_inferred') {
          this.field(content,'dose',`${range(session.estimated_fluence_j_cm2)} J/cm². ${this.labels.dose_boundary}`);
        }
        if (session.parameter_basis === 'product_inferred') this.field(content,'dose',this.labels.low_brightness_boundary);
        const sourceIds = new Set([...(session.evidence?.source_ids || []), ...(session.supporting_action?.source_ids || [])]);
        const list = element('ul','sb-sources');
        for (const id of sourceIds) {
          const source = this.config.sources?.find(s => s.id === id);
          const url = source && safeUrl(source.url);
          if (!url) continue;
          const li = element('li'); const link = element('a','',`${source.title} (${source.year})`);
          link.href = url; link.target = '_blank'; link.rel = 'noopener noreferrer';
          li.append(link); list.append(li);
        }
        if (list.children.length) { content.append(element('h4','sb-label',this.labels.sources),list); }
      }
      const article = session.article_url && safeUrl(session.article_url);
      if (article) { const link = element('a','sb-text-button',this.labels.article); link.href = article; link.target='_blank'; link.rel='noopener noreferrer'; content.append(link); }
      details.append(content); this.canvas.append(details);
    }

    coverageOptions() {
      const config = this.config.coverage_extension;
      if (!config?.options) return [];
      if (config.option_visibility !== 'filter_by_selected_goal_id') return config.options;
      return config.options.filter(option => option.eligible_goal_ids.includes('*') || option.eligible_goal_ids.includes(this.goal.id));
    }

    coverageVisibility() {
      const config = this.config.coverage_extension;
      if (this.config.schema_version === '1.7') return config.goal_visibility?.[this.goal.id] || 'collapsed';
      if (config.goal_visibility?.[this.goal.id]) return config.goal_visibility[this.goal.id];
      return config.collapsed_by_default_goal_ids?.includes(this.goal.id) ? 'collapsed' : 'expanded';
    }

    renderCoverage() {
      const config = this.config.coverage_extension;
      const options = this.coverageOptions();
      if (!options.length) return;
      const details = element('details','sb-details sb-coverage');
      details.open = this.coverageVisibility() === 'expanded';
      details.dataset.sbCoverage = '';
      const summary = element('summary','',config.title);
      summary.append(element('span','sb-optional',this.labels.optional)); details.append(summary);
      const body = element('div','sb-details-body');
      const fieldset = element('fieldset','sb-coverage-options');
      fieldset.append(element('legend','sb-label',config.question));
      body.append(element('p','sb-muted',config.helper_text));
      if (!options.some(option => option.id === this.coverageId)) {
        const legacyDefault = this.config.schema_version === '1.7' && options.find(option => option.id === 'feet_only');
        this.coverageId = (legacyDefault || options[0]).id;
      }
      options.forEach(option => {
        const label = element('label','sb-coverage-choice');
        const radio = element('input'); radio.type = 'radio'; radio.name = `coverage-${this.dataset.sectionId}`;
        radio.value = option.id; radio.dataset.sbCoverageOption = '';
        radio.checked = this.coverageId === option.id;
        label.append(radio,element('span','',option.label)); fieldset.append(label);
      });
      body.append(fieldset);
      const related = element('div','sb-related'); related.dataset.sbRelated = ''; related.setAttribute('aria-live','polite');
      body.append(related); details.append(body); this.canvas.append(details);
      details.addEventListener('toggle', () => {
        if (details.open && this.stage === 'result' && details.isConnected) this.observeCoverage(details);
      }, { signal: this.renderAbort.signal });
      this.renderRelated();
    }

    renderRelated() {
      const container = this.canvas.querySelector('[data-sb-related]');
      if (!container) return;
      container.replaceChildren();
      const option = this.config.coverage_extension.options.find(o => o.id === this.coverageId);
      if (!option || option.relationship === 'none') return;
      if (option.relationship === 'same_product_repositioned') {
        container.append(element('p','sb-muted',option.why_this_coverage_fits));
        return;
      }
      const product = this.products[option.recommended_product_key];
      const currentProductAllowed = option.relationship === 'second_unit';
      if (!product?.available || !product.coverage_verified || (!currentProductAllowed && String(product.id) === this.dataset.productId) || !product.url) {
        container.append(element('p','sb-muted',this.labels.coverage_unavailable)); return;
      }
      const href = safeUrl(product.url);
      if (!href || new URL(href).origin !== location.origin) return;
      const card = element('div','sb-product');
      if (product.image && safeUrl(product.image)) {
        const img = element('img'); img.src = safeUrl(product.image); img.alt = product.title; img.width=160; img.height=160; img.loading='lazy'; card.append(img);
      }
      const copy = element('div','sb-product-copy');
      if (option.relationship === 'add_on') copy.append(element('p','sb-eyebrow',this.labels.add_on));
      copy.append(element('h4','',product.title),element('p','',option.why_this_coverage_fits),element('strong','sb-price',product.price));
      const link = element('a','sb-button',this.labels.view_product); link.href=href; link.target='_blank'; link.rel='noopener noreferrer'; link.dataset.action='related';
      link.setAttribute('aria-label',`${this.labels.view_product}: ${product.title} (${this.labels.new_tab})`);
      copy.append(link,element('p','sb-footnote',this.labels.keep_plan)); card.append(copy); container.append(card);
    }

    disconnectObservers() { this.observeEpoch = (this.observeEpoch || 0) + 1; this.observers?.forEach(o => o.disconnect()); this.observers = []; }

    observe(node, key, callback) {
      if (!node || this.exposures.has(key) || typeof IntersectionObserver !== 'function') return;
      const epoch = this.observeEpoch;
      const observer = new IntersectionObserver(entries => {
        if (epoch !== this.observeEpoch || !this.abort || !node.isConnected) return;
        for (const entry of entries) {
          if (entry.isIntersecting && !this.exposures.has(key)) {
            this.exposures.add(key); callback(); observer.unobserve(node);
          }
        }
      }, { threshold: .5 });
      observer.observe(node); this.observers.push(observer);
    }

    reobserve() {
      if (!this.canvas || !this.abort) return;
      this.disconnectObservers();
      this.observe(this.heading,'builder',() => this.emit('session_builder_viewed'));
      this.canvas.querySelectorAll('[data-goal-id]').forEach(node => {
        const goal=this.config.goals.find(g => g.id===node.dataset.goalId);
        this.observe(node,`goal:${goal.id}`,() => this.emit('session_goal_impression',{goal_id:goal.id,display_order:goal.display_order}));
      });
      if (this.stage === 'result') {
        this.observe(this.canvas.querySelector('[data-sb-focus]'),`result:${this.resultVisit}`,() => this.emit('session_result_viewed'));
        const coverage = this.canvas.querySelector('[data-sb-coverage]');
        if (coverage?.open) this.observeCoverage(coverage);
      }
    }

    observeCoverage(details) {
      const target=details.querySelector('legend');
      this.observe(target,`coverage:${this.resultVisit}`,() => {
        if (details.open) this.emit('session_coverage_extension_viewed',{visibility_state:this.coverageVisibility()});
      });
    }

    emit(name, extra = {}) {
      const event = {
        event: name, session_id: this.sessionId, config_version: this.config.config_version,
        product_id: this.dataset.productId, section_id: this.dataset.sectionId,
        release_mode: this.config.section.release_mode,
        goal_id: this.goal?.id ?? null, branch_id: this.branch?.id ?? null,
        session_template_id: this.branch?.session_template_id ?? null, ...extra
      };
      const definition = this.config.measurement_plan?.events?.find(e => e.name===name);
      if (!definition || definition.required_fields.some(key => !(key in event))) return;
      if (this.dataset.debug === 'true') { this.eventLog.push(event); if (this.eventLog.length>100) this.eventLog.shift(); }
      const privacy=window.Shopify?.customerPrivacy;
      const previewMode=this.dataset.themeRole!=='main' || this.dataset.designMode==='true';
      if (previewMode || this.dataset.analyticsEnabled!=='true' || typeof privacy?.analyticsProcessingAllowed!=='function' || !privacy.analyticsProcessingAllowed()) return;
      this.dispatchEvent(new CustomEvent('sissilux:session-builder',{bubbles:true,detail:event}));
    }

    commercial(detail) {
      if (this.stage!=='result' || !this.branch || !detail || String(detail.product_id)!==this.dataset.productId) return;
      if (!['add_to_cart','begin_checkout','purchase'].includes(detail.event_type) || detail.confirmed!==true || !detail.event_id) return;
      if (detail.session_id && detail.session_id!==this.sessionId) return;
      const key=`${detail.event_type}:${detail.event_id}`;
      if (this.seenEventKeys.has(key)) return;
      this.seenEventKeys.add(key);
      this.emit('session_downstream_commercial_event',{event_type:detail.event_type});
    }
  }
  customElements.define('sissilux-session-builder', SessionBuilder);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sisswrap-home-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sx-home-hero')) {
  customElements.define('sx-home-hero', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.track = this.querySelector('.sxhc-track');
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-hint-go]')];
      this.querySelector('.sxhc-footer').hidden = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-hint-go')) this.go(Number(button.dataset.hintGo));
        if (button.hasAttribute('data-hint-step')) this.go(this.index + Number(button.dataset.hintStep));
      }, options);
      this.index = 0;
      this.setAttribute('data-ready', '');
      this.track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        this.suppressClick = false;
        this.drag = { id: event.pointerId, x: event.clientX, left: this.track.scrollLeft, moved: false };
      }, options);
      this.track.addEventListener('pointermove', event => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const delta = event.clientX - this.drag.x;
        if (Math.abs(delta) > 8 && !this.drag.moved) {
          this.drag.moved = true;
          this.track.setPointerCapture(event.pointerId);
          this.track.setAttribute('data-dragging', '');
        }
        if (this.drag.moved) this.track.scrollLeft = this.drag.left - delta;
      }, options);
      const finish = () => {
        if (!this.drag) return;
        this.suppressClick = this.drag.moved;
        this.track.removeAttribute('data-dragging');
        if (this.drag.moved) {
          const distance = this.track.scrollLeft - this.drag.left;
          const origin = Math.round(this.drag.left / this.track.clientWidth);
          const target = Math.abs(distance) > 40 ? origin + Math.sign(distance) : origin;
          this.go(Math.max(0, Math.min(this.slides.length - 1, target)));
        }
        this.drag = null;
      };
      this.track.addEventListener('pointerup', finish, options);
      this.track.addEventListener('pointercancel', finish, options);
      this.track.addEventListener('pointerleave', () => { if (this.drag && !this.drag.moved) this.drag = null; }, options);
      this.track.addEventListener('dragstart', event => event.preventDefault(), options);
      this.track.addEventListener('click', event => {
        if (this.suppressClick) { event.preventDefault(); event.stopPropagation(); this.suppressClick = false; }
      }, { ...options, capture: true });
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          const box = this.track.getBoundingClientRect();
          const distances = this.slides.map(slide => Math.abs(slide.getBoundingClientRect().left - box.left));
          this.sync(distances.indexOf(Math.min(...distances)));
        });
      }, { ...options, passive: true });
      this.addEventListener('keydown', event => {
        if (!this.track.contains(event.target) || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1);
        this.go(index);
      }, options);
      this.resize = new ResizeObserver(() => this.go(this.index, false));
      this.resize.observe(this.track);
      this.sync(0);
    }
    go(index, animate = true) {
      index = (index + this.slides.length) % this.slides.length;
      this.sync(index);
      const left = this.slides[index].getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
      this.track.scrollTo({ left, behavior: animate && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant' });
    }
    sync(index) {
      this.index = index;
      this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
      this.slides.forEach((slide, i) => {
        if (i !== index && slide.contains(document.activeElement)) this.track.focus({ preventScroll: true });
        slide.inert = i !== index;
        slide.setAttribute('aria-hidden', String(i !== index));
      });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sisswrap-home-shop"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sisswrap-home-shop'))customElements.define('sisswrap-home-shop',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.cards=[...this.querySelectorAll('.product')];this.selected='All';this.querySelectorAll('.controls').forEach(x=>x.hidden=false);this.querySelectorAll('[data-area]').forEach(b=>{const area=b.dataset.area;if(area!=='All'&&!this.cards.some(c=>c.dataset.areas.split(',').includes(area)))b.hidden=true;b.addEventListener('click',()=>{this.selected=area;this.render();this.querySelector('[data-grid]').scrollLeft=0})});this.render()}
render(){let count=0;this.cards.forEach(c=>{c.hidden=this.selected!=='All'&&!c.dataset.areas.split(',').includes(this.selected);if(!c.hidden)count++});this.dataset.visibleCount=String(count);this.querySelector('[data-count]').textContent=count+' '+this.dataset.countLabel;this.querySelector('[data-empty]').hidden=count>0;this.querySelectorAll('[data-area]').forEach(b=>{const active=b.dataset.area===this.selected;b.classList.toggle('active',active);b.setAttribute('aria-pressed',String(active))});this.dispatchEvent(new CustomEvent('swh:filter-changed'))}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sx-massage-spotlight"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sx-massage-spotlight')) {
  customElements.define('sx-massage-spotlight', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.track = this.querySelector('.sxms-track');
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-hint-go]')];
      this.querySelector('.sxhc-footer').hidden = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-hint-go')) this.go(Number(button.dataset.hintGo));
        if (button.hasAttribute('data-hint-step')) this.go(this.index + Number(button.dataset.hintStep));
      }, options);
      this.addEventListener('shopify:block:select', event => { const i = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target)); if (i >= 0) this.go(i, false); }, options);
      this.index = 0;
      this.setAttribute('data-ready', '');
      this.track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button, input, select, label')) return;
        this.suppressClick = false;
        this.drag = { id: event.pointerId, x: event.clientX, left: this.track.scrollLeft, moved: false };
      }, options);
      this.track.addEventListener('pointermove', event => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const delta = event.clientX - this.drag.x;
        if (Math.abs(delta) > 8 && !this.drag.moved) {
          this.drag.moved = true;
          this.track.setPointerCapture(event.pointerId);
          this.track.setAttribute('data-dragging', '');
        }
        if (this.drag.moved) this.track.scrollLeft = this.drag.left - delta;
      }, options);
      const finish = () => {
        if (!this.drag) return;
        this.suppressClick = this.drag.moved;
        this.track.removeAttribute('data-dragging');
        if (this.drag.moved) {
          const distance = this.track.scrollLeft - this.drag.left;
          const origin = Math.round(this.drag.left / this.track.clientWidth);
          const target = Math.abs(distance) > 40 ? origin + Math.sign(distance) : origin;
          this.go(Math.max(0, Math.min(this.slides.length - 1, target)));
        }
        this.drag = null;
      };
      this.track.addEventListener('pointerup', finish, options);
      this.track.addEventListener('pointercancel', finish, options);
      this.track.addEventListener('pointerleave', () => { if (this.drag && !this.drag.moved) this.drag = null; }, options);
      this.track.addEventListener('dragstart', event => event.preventDefault(), options);
      this.track.addEventListener('click', event => {
        if (this.suppressClick) { event.preventDefault(); event.stopPropagation(); this.suppressClick = false; }
      }, { ...options, capture: true });
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          const box = this.track.getBoundingClientRect();
          const distances = this.slides.map(slide => Math.abs(slide.getBoundingClientRect().left - box.left));
          this.sync(distances.indexOf(Math.min(...distances)));
        });
      }, { ...options, passive: true });
      this.addEventListener('keydown', event => {
        if (!this.track.contains(event.target) || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1);
        this.go(index);
      }, options);
      this.resize = new ResizeObserver(() => this.go(this.index, false));
      this.resize.observe(this.track);
      this.sync(0);
    }
    go(index, animate = true) {
      index = (index + this.slides.length) % this.slides.length;
      this.sync(index);
      const left = this.slides[index].getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
      this.track.scrollTo({ left, behavior: animate && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant' });
    }
    sync(index) {
      this.index = index;
      this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
      this.slides.forEach((slide, i) => {
        if (i !== index && slide.contains(document.activeElement)) this.track.focus({ preventScroll: true });
        slide.inert = i !== index;
        slide.setAttribute('aria-hidden', String(i !== index));
      });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
